export enum InputDataTestIdEnum {
  INPUT_CONTAINER = 'input-container',
  INPUT_START_ICON = 'start-icon',
  INPUT_END_ICON = 'end-icon',
  INPUT_CLEAR_BUTTON = 'clear-button',
}
